module.exports = {"requirements":"You must have cookies and Javascript enabled in your browser.","legalPrefix":"©","legalSuffix":"showtix4u All rights reserved.","links":[{"text":"Contact us","url":"https://www.showtix4u.com/#contact","external":true},{"text":"Privacy policy","url":"/privacy-policy","external":false},{"text":"Terms of Service","url":"/terms","external":false}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/locales/fr.json
// module id = 796
// module chunks = 0